import { render, staticRenderFns } from "./modifyPreDate.vue?vue&type=template&id=b4ec534c&scoped=true"
import script from "./modifyPreDate.vue?vue&type=script&lang=js"
export * from "./modifyPreDate.vue?vue&type=script&lang=js"
import style0 from "./modifyPreDate.vue?vue&type=style&index=0&id=b4ec534c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ec534c",
  null
  
)

export default component.exports